export default {
  'app.setting.pagestyle': 'Style de la page',
  'app.setting.pagestyle.dark': 'Style sombre',
  'app.setting.pagestyle.light': 'Style clair',
  'app.setting.content-width': 'Largeur du contenu',
  'app.setting.content-width.fixed': 'Fixe',
  'app.setting.content-width.fluid': 'Fluide',
  'app.setting.themecolor': 'Couleur du thème',
  'app.setting.themecolor.dust': 'Rouge poussière',
  'app.setting.themecolor.volcano': 'Volcan',
  'app.setting.themecolor.sunset': 'Orange coucher de soleil',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Vert polaire',
  'app.setting.themecolor.daybreak': 'Bleu aurore (par défaut)',
  'app.setting.themecolor.geekblue': 'Bleu geek',
  'app.setting.themecolor.purple': 'Violet impérial',
  'app.setting.navigationmode': 'Mode de navigation',
  'app.setting.sidemenu': 'Menu latéral',
  'app.setting.topmenu': 'Menu supérieur',
  'app.setting.fixedheader': 'En-tête fixe',
  'app.setting.fixedsidebar': 'Barre latérale fixe',
  'app.setting.fixedsidebar.hint': 'Fonctionne avec le menu latéral',
  'app.setting.hideheader': "Masquer l'en-tête au défilement",
  'app.setting.hideheader.hint':
    "Fonctionne lorsque le masquage de l'en-tête est activé",
  'app.setting.othersettings': 'Autres paramètres',
  'app.setting.weakmode': 'Mode daltonien',
  'app.setting.copy': 'Copier la configuration',
  'app.setting.copyinfo':
    'Copié avec succès, veuillez remplacer defaultSettings dans src/models/setting.js',
  'app.setting.production.hint':
    "Le panneau de configuration s'affiche uniquement en environnement de développement, veuillez modifier manuellement",
};
